/*
 * @Description:业务插件管理--容联外呼人员管理/外呼人员管理/外呼池管理
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  条: '条',
  备注: '备注',
  新建: '新建',
  号码: '号码',
  移除: '移除',
  员工: '员工',
  操作: '操作',
  固话: '固话',
  已选择: '已选择',
  管理员: '管理员',
  创建人: '创建人',
  号码池: '号码池',
  所属部门: '所属部门',
  普通坐席: '普通坐席',
  创建时间: '创建时间',
  号码详情: '号码详情',
  新增号码: '新增号码',
  号码数量: '号码数量',
  外呼号码: '外呼号码',
  号码状态: '号码状态',
  最后更新人: '最后更新人',
  主叫号码池: '主叫号码池',
  被叫号码池: '被叫号码池',
  请选择员工: '请选择员工',
  请输入号码: '请输入号码',
  号码归属地: '号码归属地',
  外呼池管理: '外呼池管理',
  新增号码池: '新增号码池',
  外呼池名称: '外呼池名称',
  外呼池编号: '外呼池编号',
  所属归属池: '所属归属池',
  外呼中间号: '外呼中间号',
  外呼号码管理: '外呼号码管理',
  搜索外呼号码: '搜索外呼号码',
  外呼人员管理: '外呼人员管理',
  被叫外显号码: '被叫外显号码',
  主叫外显号码: '主叫外显号码',
  最后更新时间: '最后更新时间',
  绑定员工姓名: '绑定员工姓名',
  外呼系统工号: '外呼系统工号',
  外呼系统角色: '外呼系统角色',
  设置默认号码: '设置默认号码',
  默认拨打号码: '默认拨打号码',
  请选择员工姓名: '请选择员工姓名',
  员工个人手机号: '员工个人手机号',
  主叫号码池编号: '主叫号码池编号',
  主叫号码池名称: '主叫号码池名称',
  被叫号码池编号: '被叫号码池编号',
  被叫号码池名称: '被叫号码池名称',
  绑定员工手机号: '绑定员工手机号',
  绑定外呼中间号: '绑定外呼中间号',
  确认移除该号码: '确认移除该号码',
  解绑的外呼中间号: '解绑的外呼中间号',
  绑定的外呼中间号: '绑定的外呼中间号',
  获取固话列表失败: '获取固话列表失败',
  只能选择一个员工: '只能选择一个员工',
  请选择主叫号码池: '请选择主叫号码池',
  请选择被叫号码池: '请选择被叫号码池',
  请输入外呼池编号: '请输入外呼池编号',
  请输入外呼池名称: '请输入外呼池名称',
  请输入号码归属地: '请输入号码归属地',
  设置默认外呼中间号: '设置默认外呼中间号',
  批量编辑主叫号码池: '批量编辑主叫号码池',
  批量编辑被叫号码池: '批量编辑被叫号码池',
  批量绑定外呼中间号: '批量绑定外呼中间号',
  批量解绑外呼中间号: '批量解绑外呼中间号',
  移除后该号码将不能使用: '移除后该号码将不能使用',
  批量设置默认外呼中间号: '批量设置默认外呼中间号',
  请输入绑定员工手机号: '请输入绑定员工手机号',
  输入外呼系统工号: '输入外呼系统工号',
  搜索号码: '搜索号码',
  请选择外呼系统角色: '请选择外呼系统角色',
  容联外呼人员管理: '容联外呼人员管理',
  容联外呼中间号: '容联外呼中间号'
};
